import ToggleGroup, {
  ToggleButton,
  ToggleButtonSize,
} from '@/components/ui/custom/dataInput/ToggleGroup';
import { ProjectCourseFlagEnum } from '@/models/Flag';
import { useTranslation } from 'react-i18next';
import { CarouselFilterProps } from './CarouselFilterProps';

export type CourseTypeFilterValue = ProjectCourseFlagEnum | 'all';

type CourseTypeFilterProps = CarouselFilterProps & {
  size?: ToggleButtonSize;
};

const CourseTypeFilter = ({
  filter,
  onFilter,
  size,
}: CourseTypeFilterProps) => {
  const { t: tCourseType } = useTranslation('translation', {
    keyPrefix: 'filters',
  });
  const { t } = useTranslation('translation', {
    keyPrefix: 'projects.page',
  });
  const onChange = (courseType: CourseTypeFilterValue) => {
    if (courseType === 'all') {
      onFilter?.({ courseType: [] });
      return;
    }
    onFilter?.({
      courseType: [courseType],
    });
  };
  const buttons: ToggleButton<CourseTypeFilterValue>[] = [
    {
      text: t('all'),
      value: 'all',
      className: {
        regular: 'border-accent text-accent enabled:hover:bg-accent-content',
        active: 'bg-accent border-accent',
      },
    },
    {
      text: tCourseType(ProjectCourseFlagEnum.CTRL_KIDS),
      value: ProjectCourseFlagEnum.CTRL_KIDS,
      className: {
        regular: 'border-warning text-warning enabled:hover:bg-warning-content',
        active: 'bg-warning border-warning',
      },
    },
    {
      text: tCourseType(ProjectCourseFlagEnum.CTRL_TEENS),
      value: ProjectCourseFlagEnum.CTRL_TEENS,
      className: {
        regular: 'text-primary',
      },
    },
    {
      text: tCourseType(ProjectCourseFlagEnum.CTRL_YOUNG),
      value: ProjectCourseFlagEnum.CTRL_YOUNG,
      className: {
        regular:
          'border-secondary text-secondary enabled:hover:bg-secondary-content',
        active: 'bg-secondary border-secondary',
      },
    },
  ];
  return (
    <ToggleGroup
      buttons={buttons}
      className={{ base: 'md:justify-start justify-end' }}
      onChange={onChange}
      value={filter?.courseType?.[0] || 'all'}
      size={size || 'small'}
      exclusive
    />
  );
};

export default CourseTypeFilter;
